const types = {
	affiliate: 'affiliate',
	admin: 'admin'
};

const locale = {
	ru: {
		affiliate: 'партнер',
		admin: 'админ'
	},
	en: types,
	de: {
		affiliate: 'Partner',
		admin: 'Admin'
	},
	vi: types,
	uk: types,
	th: {
		affiliate: 'หุ้นส่วน',
		admin: 'ผู้ดูแลระบบ'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/user-types.js